import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { Charge } from '.';
import validate from '../helpers/emitChargesInformationValidate';
import focusInputOnError from '../helpers/focusInputOnError';
import { chargesToArray } from '../helpers/utils';
import { env } from '../env';

interface IEmitChargesInformationFormProps {
  charges: string;
  handleSubmit: () => void;
  previousPage: () => void;
}

export function EmitChargesInformationForm(
  props: IEmitChargesInformationFormProps,
) {
  const { charges, previousPage, handleSubmit } = props;
  const [currentCharge, setCurrentCharge] = useState(0);
  const [chargesCount] = useState(chargesToArray(charges));

  const nextCurrentCharge = () => {
    setCurrentCharge(currentCharge + 1);
  };
  const prevCurrentCharge = () => {
    setCurrentCharge(currentCharge - 1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvCharges',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);

      ReactGA.send({
        hitType: 'pageview',
        location: 'salud.segurosfalabella.com/salud/informacion-de-las-cargas',
        title: 'Seguro Salud Complementario',
        user_id: sessionStorage.getItem('userId'),
      });

      // Funnel step viewed
      ReactGA.event("funnel_step_viewed", {
        'funnel_name': 'contratacion-seguro',
        'product_name': 'web-salud-complementario',
        'funnel_step_name': 'paso-informacion-cargas'
      });
    }
  }, []);

  return (
    <form onSubmit={handleSubmit} noValidate={true}>
      <div className="row justify-content-center flex-column">
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto">
          <h3 className="wizard-card--title px-24 d-flex flex-column">
            Datos asegurado{Number(charges) > 1 && "s"} adicional{Number(charges) > 1 && "es"}
            <span>Asegurado adicional nº{currentCharge + 1}</span>
          </h3>
        </div>
        {/* {charges === '3' && (
          <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
            <label htmlFor="charges">Cantidad de cargas</label>
            <Field
              name="charges"
              component={FormSelect}
              options={chargesOptions}
              onChange={changeChargesCount}
              showDefault={false}
            />
          </div>
        )} */}
        {chargesCount.map(index => (
          <Charge key={index} index={index} current={currentCharge} />
        ))}
      </div>
      <footer className="fixed-footer-form emit-steps">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-7 col-lg-6 pdy-16 d-flex justify-content-between align-content-center align-items-center">
              <button
                className="btn white back-to-matrix col-4 d-flex justify-content-center align-content-center align-items-center"
                type="button"
                onClick={currentCharge === 0 ? previousPage : prevCurrentCharge}
              >
                <i className="material-icons">chevron_left</i>
              </button>
              {
                currentCharge !== Number(charges) - 1 ?
                  <span
                    className="btn primary go-to-contact-info col-8 d-flex justify-content-center align-content-center align-items-center"
                    onClick={nextCurrentCharge}
                  >
                    Siguiente
                  </span> :
                  <button
                    className="btn primary go-to-contact-info col-8"
                    type="submit"
                  >
                    Continuar
                  </button>
              }
            </div>
          </div>
        </div>
      </footer>
    </form>
  );
}

export default withRouter(
  reduxForm<any, any>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'proposal',
    onSubmitFail: focusInputOnError,
    validate,
  })(EmitChargesInformationForm),
);
